import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  template: `
    <div class="custom-snackbar" [class]="data.type">
      <div class="snackbar-icon">
        <img [src]="iconSrc" [alt]="data.type" />
      </div>
      <div class="snackbar-content">
        <h3>{{ data.title }}</h3>
        <p [innerHTML]="data.message"></p>
        @if(data.linkText) {
        <a  class="snackbar-link" href="#" (click)="goToReport()">{{ data.linkText }}</a> }
      </div>
      <button class="snackbar-close" (click)="close()">
        <span>&#10005;</span>
      </button>
    </div>
  `,
  styleUrls: ['./custom-snackbar.component.scss']
})
export class CustomSnackbarComponent {
  iconSrc = '';
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      type: 'success' | 'error' | 'warning',
      title: string,
      message: string,
      linkText?: string
    },
    private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>
  ) {
    this.iconSrc = this.getIcon(data.type);
  }

  getIcon(type: string) {
    switch (type) {
      case 'success': return 'assets/icons/check_circle_26.svg';
      case 'error': return 'assets/icons/cancel_26.svg';
      case 'warning': return 'assets/icons/error_26.svg';
      default: return 'assets/icons/check_circle_26.svg';
    }
  }

  close() {
    this.snackBarRef.dismiss();
  }

  goToReport() {
    this.snackBarRef.dismiss();
  }
}
